import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-header-bar',
    templateUrl: './sera-header-bar.component.html',
    styleUrls: ['./sera-header-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraHeaderBarComponent {
    @Input() text!: string;
}
